module.exports = {"id":"go","name":"Go","isInbuilt":true,"theme":{"type":"light","palette":{"primaryColor":{"id":"green","shadeIndex":13},"secondaryColor":{"id":"red","shadeIndex":4},"backgroundColor":{"id":"lightGreen","shadeIndex":1},"custom":{"today":"#1455c0","soon":"#FF9300","overdue":"#F00","later":"#22B30B","unreadItem":"#1455c0","highPriority":"orange"}},"hideTaskEditIcon":false,"isDense":false,"typography":{"useNextVariants":true}}}


//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-themes/Go.json
// module id = 708
// module chunks = 0